module.exports = "https://r.zoocdn.com/_next/static/images/home-worth-5f2f0a36754083f01684e97cf3f1ab0d.svg";